import { gql } from '@apollo/client';

export const GET_LOCAL_WORKSPACE = gql`
    query localWorkspace {
        localWorkspace @client
    }
`;
